export const SET_TAB_INDEX = 'tabs/SET_TAB_INDEX';
export const SET_VISIBLE_TABS = 'tabs/SET_VISIBLE_TABS';
